// extracted by mini-css-extract-plugin
export default {"container":"About_container__ngSzB","wrapper":"About_wrapper__XaFNV"};